import React from 'react'
import KeyTypeMappings from './key-type-mappings/KeyTypeMappings'

const MainKeyMappings = (): JSX.Element => {
  return (
    <div>
      <div style={{ marginTop: '10px' }}>
        <div style={{ marginTop: '0px' }}>
          <KeyTypeMappings />
        </div>
      </div>
    </div>
  )
}
export default MainKeyMappings
